import BaseApi from '../base/base'

export default class ExamPurchaseApi extends BaseApi {
  constructor() {
    super()
    this.path = '/exam_purchases'
  }

  async show(examId, params={}) {
    this.path = `/exams/${examId}/exam_purchases/0/`
    const response = await this.getRequest(params)
    return response.data
  }

  async create(examId, params) {
    this.path = `/exams/${examId}/exam_purchases/`
    const response = await this.postRequest(params)
    return response.data
  }

  async getCoupon(examId, params) {
    this.path = `/exams/${examId}/exam_purchases/get_coupon`
    const response = await this.getRequest(params)
    return response.data
  }
}
